'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactionImage = require('../../ReactionImage');

var _ReactionImage2 = _interopRequireDefault(_ReactionImage);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalNav = function ModalNav(props) {
  return _react2.default.createElement(
    'ul',
    { className: 'reaction-nav' },
    props.existingReactions.map(function (reaction) {
      return _react2.default.createElement(
        'li',
        {
          key: reaction,
          className: (0, _classnames2.default)({ selected: reaction === props.selectedReaction })
        },
        _react2.default.createElement(
          'a',
          { className: 'reaction-nav-item', href: '#', onClick: function onClick(e) {
              return props.onClickReaction(e, reaction);
            } },
          _react2.default.createElement(_ReactionImage2.default, { reactionType: reaction })
        )
      );
    })
  );
};

ModalNav.propTypes = {
  existingReactions: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  onClickReaction: _react.PropTypes.func.isRequired,
  selectedReaction: _react.PropTypes.string
};

exports.default = ModalNav;